import { useState, useEffect } from "react";
import { getMasthead } from "../api/widgets/masthead/requests";

function useStoryblokMasthead() {
  const [masthead, setMasthead] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getMasthead()
      .then((story) => {
        if (story) setMasthead(story);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setIsLoading(false))
  }, []);

  return [masthead, isLoading];
}

export { useStoryblokMasthead };
